import { Box, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { uploadIncidentXml } from "../../store/incidentsReducer";
import { toast } from "react-toastify";
import { useRef, useState } from "react";
import ImportErrorDialog from "../../components/Incidents/modals/ImportErrorDialog";

const ImportXml = ({ incidentsRequest }) => {
  const dispatch = useDispatch();

  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);

  const fileInputRef = useRef(null);

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
    setErrorDetails(null);
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile && selectedFile.type === "text/xml") {
      try {
        const response = await dispatch(uploadIncidentXml(selectedFile));

        if (response === true) {
          if (incidentsRequest) incidentsRequest();
          toast.success("Your incident has been successfully imported.", {});
        } else {
          setErrorDetails({ error: response.message, message: response.response?.data?.message });
          setOpenErrorDialog(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        // Clear the input value
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } else {
      // Clear the input value
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  return (
    <>
      <Box>
        <input
          accept=".xml"
          style={{ display: "none" }}
          id="xml-file-upload"
          type="file"
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        <label htmlFor="xml-file-upload">
          <Button
            component="span"
            variant="outlined"
            sx={{
              background: "#F5F5F5",
              color: "#000",
              border: "1px solid #F5F5F5",
              fontSize: "16px",
              "&:hover": {
                borderColor: "darkgray",
              },
            }}
            endIcon={<ExpandMoreIcon sx={{ color: "gray" }} />}
          >
            Import
          </Button>
        </label>
      </Box>
      <ImportErrorDialog open={openErrorDialog} onClose={handleCloseErrorDialog} errorDetails={errorDetails} />
    </>
  );
};

export default ImportXml;
